"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const org_transcrypt___runtime___js_1 = require("./org.transcrypt.__runtime__.js");
var __name__ = 'tfchain.polyfill.array';
exports.new_array = function (n) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'n':
                        var n = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var arr = null;
    arr = new Array(n).fill(0);
    return arr;
};
exports.as_array = function (value) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'value':
                        var value = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var out = null;
    out = Array.from(value);
    return out;
};
exports.as_uint8_array = function (value) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'value':
                        var value = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var out = null;
    out = new Uint8Array(value);
    return out;
};
exports.is_uint8_array = function (arr) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'arr':
                        var arr = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var result = false;
    result = arr instanceof Uint8Array;
    return result;
};
exports.concat = function (a, b) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'a':
                        var a = __allkwargs0__[__attrib0__];
                        break;
                    case 'b':
                        var b = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (org_transcrypt___runtime___js_1.isinstance(a, org_transcrypt___runtime___js_1.tuple([org_transcrypt___runtime___js_1.bytes, org_transcrypt___runtime___js_1.bytearray, org_transcrypt___runtime___js_1.tuple, org_transcrypt___runtime___js_1.list]))) {
        var a = (function () {
            var __accu0__ = [];
            for (var v of a) {
                __accu0__.append(v);
            }
            return __accu0__;
        })();
        if (org_transcrypt___runtime___js_1.isinstance(b, org_transcrypt___runtime___js_1.tuple([org_transcrypt___runtime___js_1.bytes, org_transcrypt___runtime___js_1.bytearray, org_transcrypt___runtime___js_1.tuple, org_transcrypt___runtime___js_1.list]))) {
            a.extend(b);
        }
        else {
            for (var v of b) {
                a.append(v);
            }
        }
        return a;
    }
    var c = null;
    c = new (a.constructor)(a.length + b.length);
    c.set(a, 0);
    c.set(b, a.length);
    return c;
};
exports.slice_array = function (arr, begin, end) {
    if (typeof end == 'undefined' || (end != null && end.hasOwnProperty("__kwargtrans__"))) {
        ;
        var end = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'arr':
                        var arr = __allkwargs0__[__attrib0__];
                        break;
                    case 'begin':
                        var begin = __allkwargs0__[__attrib0__];
                        break;
                    case 'end':
                        var end = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var out = null;
    if (end == null) {
        out = arr.slice(begin);
    }
    else {
        out = arr.slice(begin, end);
    }
    return out;
};
exports.reverse = function (a) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'a':
                        var a = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var out = null;
    out = a.slice().reverse();
    return out;
};
exports.index_of = function (arr, x) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'arr':
                        var arr = __allkwargs0__[__attrib0__];
                        break;
                    case 'x':
                        var x = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var i = null;
    i = arr.indexOf(x);
    return i;
};
exports.is_empty = function (arr) {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'arr':
                        var arr = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    var result = false;
    result = (arr === null || arr.length === 0);
    return result || !(arr) || org_transcrypt___runtime___js_1.len(arr) == 0;
};
exports.py_sort = function (arr, f, reverse) {
    if (typeof reverse == 'undefined' || (reverse != null && reverse.hasOwnProperty("__kwargtrans__"))) {
        ;
        var reverse = false;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'arr':
                        var arr = __allkwargs0__[__attrib0__];
                        break;
                    case 'f':
                        var f = __allkwargs0__[__attrib0__];
                        break;
                    case 'reverse':
                        var reverse = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    arr = arr.slice();
    arr.sort(f);
    if (reverse === true) {
        arr.reverse();
    }
    return arr;
};
exports.py_pop = function (arr, index) {
    if (typeof index == 'undefined' || (index != null && index.hasOwnProperty("__kwargtrans__"))) {
        ;
        var index = null;
    }
    ;
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
                switch (__attrib0__) {
                    case 'arr':
                        var arr = __allkwargs0__[__attrib0__];
                        break;
                    case 'index':
                        var index = __allkwargs0__[__attrib0__];
                        break;
                }
            }
        }
    }
    else {
    }
    if (org_transcrypt___runtime___js_1.isinstance(arr, org_transcrypt___runtime___js_1.list)) {
        return arr.py_pop(index);
    }
    if (index == null) {
        var val = null;
        val = arr.pop();
        return val;
    }
    if (index == 0) {
        var val = null;
        val = arr.shift();
        return val;
    }
    var val = null;
    val = arr[index];
    delete arr[index];
    return val;
};
//# sourceMappingURL=tfchain.polyfill.array.map
//# sourceMappingURL=tfchain.polyfill.array.js.map